<template>
  <div>
    <headerSection :navActiveItem="navActiveItem"></headerSection>
    <contact></contact>
    <footerSection></footerSection>
    <a href="#" class="go-top"><i class="fa fa-angle-up"></i></a>
  </div>
</template>

<script>
import headerSection from '../components/header.vue';
import contact from '../components/contact.vue';
import footerSection from '../components/footer.vue';
import '../../static/css/animate.min.css';
import WOW from '../../static/js/wow.min.js';
  export default {
    components: {
      headerSection,contact,footerSection
    },
    data(){
      return {
        navActiveItem: {
          contact:true,
        }
      }
    },
    mounted: function() {
       $(window).scroll(function() {
      if ($(this).scrollTop() > 200) {
          $('.go-top').fadeIn(200);
            } else {
                $('.go-top').fadeOut(200);
           }
        });
          // Animate the scroll to top
        $('.go-top').click(function(event) {
          event.preventDefault();
        $('html, body').animate({scrollTop: 0}, 300);
    });
    new WOW.WOW().init();
    $('html, body').animate({scrollTop: 0}, 0);
    }
   }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/contact.vue